import { AfterContentInit, Component, ElementRef, EventEmitter, Input, NgModule, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { Error } from './error';

import { DateEditRoutingModule } from './dateedit.routing.module';

declare const $: any;
const errorMessage: any = {
  required: 'Ce champ est requis'
};

@Component({
  selector: 'dateedit',
  template: `
  <div [formGroup]="form" class="md-form form-sm" [ngClass]="{'has-error':error}" style="display: flex;">
    <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value}" style="top: -0.3rem;"></i>
    <input type="text" data-value="{{valueDate}}" id="{{name}}" class="form-control datepicker" [ngClass]="{'invalid':error}"
      [readonly]="readonly" [formControl]="control" [ngStyle]="{'font-style': (readonly ? 'italic' :'') }" style="max-width: 70px;cursor:pointer;overflow: hidden;text-overflow: ellipsis;height: 1.1rem;"
      #datepicker>
    <label for="{{name}}" [ngClass]="{'active':control.value}" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
      [ngStyle]="{'top': (!control.value ? '.3rem' :'')}">
      <em *ngIf="readonly">{{caption}}</em>
      <b *ngIf="!readonly">{{caption}}</b>
      <span *ngIf="required && !control.value" style="color: red;">
        <b>*</b>
      </span>
      <i *ngIf="readonly" class="fa fa-lock" style="color:rgba(0, 0, 0, 0.54) !important;"></i>
    </label>
    <input *ngIf="showHour" type="text" [readonly]="readonly" [ngClass]="{'invalid':error}" [ngStyle]="{'font-style': (readonly ? 'italic' :'') }"
      data-value="{{valueHour}}" class="form-control timepicker" style="height: 1.1rem; margin-left: 0.4rem; width: 50px; text-align: center!important;"
      #timepicker>
  </div>
  <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '34px' :'')}" style="font-size: 15px">
    <b>{{ error }}</b>
  </span>`,
  encapsulation: ViewEncapsulation.None
})

export class DateEditComponent {
  @Input() public name: string = '';
  public namehour: string;
  @Input() public required: boolean = false;
  @Input() public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public showHour: Boolean = false;
  @Input() public caption: string = '';
  @Input() public length: string = '0';
  @Input() public enabled: Boolean = false;
  @Input() public valueDate: any;
  @Input() public valueHour: any;
  @Input() public glyph: string = '';
  @Input() public form: FormGroup;
  @Input() public error: any;
  public date: any;
  public elementRef: ElementRef;
  @ViewChild('datepicker') datepicker: any;
  @ViewChild('timepicker') timepicker: any;
  public picker: any;
  @Output() updated: EventEmitter<any> = new EventEmitter();

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    this.namehour = this.name + 'hour';
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    $(this.datepicker.nativeElement).pickadate({
      container: 'body',
      onSet: (context: any) => {
        if (context && context.select) {
          this.changeDate(context.select);
          if (this.showHour) this.changeHour($(this.timepicker.nativeElement).pickatime()[0].value);
        } else if (context) {
          this.changeDate(null);
        }
      }
    });
    this.picker = $(this.datepicker.nativeElement).pickadate('picker');
    if (this.showHour) {
      $(this.timepicker.nativeElement).pickatime({
        twelvehour: false,
        afterDone: () => {
          this.changeHour($(this.timepicker.nativeElement).pickatime()[0].value);
        }
      });
    }
    //this.changeDate(this.control.value, true);
    //if (this.showHour) {
      this.changeHour(this.convertLongToHourFormat(this.control.value));
    //}
    if (this.readonly) {
      this.picker.stop();
    } else {
      this.picker.start();
    }
    if (this.required) {
      this.control.setValidators(Validators.required);
    }
    this.control.valueChanges.subscribe((x) => {
      this.returnError();
    });
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          this.error += errorMessage[key] + ' ';
        }
      }
    }
  }

  convertLongToHourFormat(valueInput: any): any {
    if (valueInput) {
      let date: Date = new Date(valueInput);
      let hour: string = date.getHours().toString();
      let minute: string = date.getMinutes().toString();
      this.valueHour = ("0" + hour).substring(hour.length - 1) + ":" + ("0" + minute).substring(minute.length - 1);
      return this.valueHour;
    } else {
      this.valueHour = '';
      return null;
    }
  }

  changeHour(valueInput: any) {
    if (this.control.value) {
      let hour: number = 0;
      let minute: number = 0;
      if (valueInput && valueInput.length == 5) {
        hour = parseInt(valueInput.substring(0, 2));
        minute = parseInt(valueInput.substring(3));
      }
      let date: Date = new Date(this.transformDate(this.control.value));
      date.setHours(hour, minute, 0, 0);
      this.changeDate(date, true);
      this.valueDate = date.toLocaleDateString();
      //this.control.patchValue(date);
    }
  }

  changeDate(valueInput: any, init?: boolean): any {
    let myDate = null;
    let value = '';
    if (valueInput) {
      valueInput = new Date(this.transformDate(valueInput));
      //valueInput.setHours(0, 0, 0, 0);
      value = valueInput.toLocaleDateString();
      myDate = valueInput.toISOString();
    } else {
      this.valueHour = '';
    }
    if ((init) || (this.control.value != myDate)) {
      this.control.patchValue(myDate);
      this.valueDate = value;
      if (!init) {
        this.updated.emit(myDate);
      }
    }
  }

  public transformDate(dateEntry: any): any {
    let date: any = null;
    if (dateEntry) {
      date = new Date(dateEntry);
    }
    return date;
  }

  setMin(min: any) {
    let minDate: Date = min;
    if (minDate) {
      minDate = new Date(this.transformDate(minDate));
      minDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
      this.picker.set('min', minDate);
    } else {
      this.picker.set('min', false);
    }
    if (this.control.value && min) {
      if (this.control.value < min) {
        this.control.patchValue(null);
        this.valueDate = '';
      }
    }
  }

  setMax(max: any) {
    let maxDate: Date = max;
    if (maxDate) {
      maxDate = new Date(this.transformDate(maxDate));
      maxDate = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
      this.picker.set('max', maxDate);
    } else {
      this.picker.set('max', false);
    }
    if (this.control.value && max) {
      if (this.control.value > max) {
        this.control.patchValue(null);
        this.valueDate = '';
      }
    }
  }

  setReadonly(readonly: boolean) {
    this.readonly = readonly;
    if (this.readonly) {
      this.picker.stop();
    } else {
      this.picker.start();
    }
  }
}
